// // import { useLayoutEffect, useRef, useState } from 'react';
// // import { gsap } from 'gsap';
// // // Menggunakan react-icons seperti di contoh Anda
// // import { GoArrowUpRight } from 'react-icons/go';
// // import './CardNav.css'; // Path disesuaikan dengan alias @/

// // const CardNav = ({
// //   logo,
// //   logoAlt = 'Logo',
// //   items,
// //   className = '',
// //   ease = 'power3.out',
// //   baseColor = '#fff',
// //   menuColor,
// //   buttonBgColor,
// //   buttonTextColor,
// //   ctaText = 'Get Started' // Menambahkan prop untuk teks tombol
// // }) => {
// //   const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);
// //   const [isExpanded, setIsExpanded] = useState(false);
// //   const navRef = useRef(null);
// //   const cardsRef = useRef([]);
// //   const tlRef = useRef(null);

// //   const calculateHeight = () => {
// //     const navEl = navRef.current;
// //     if (!navEl) return 260;

// //     const isMobile = window.matchMedia('(max-width: 768px)').matches;
// //     if (isMobile) {
// //       const contentEl = navEl.querySelector('.card-nav-content');
// //       if (contentEl) {
// //         const wasVisible = contentEl.style.visibility;
// //         const wasPointerEvents = contentEl.style.pointerEvents;
// //         const wasPosition = contentEl.style.position;
// //         const wasHeight = contentEl.style.height;

// //         contentEl.style.visibility = 'visible';
// //         contentEl.style.pointerEvents = 'auto';
// //         contentEl.style.position = 'static';
// //         contentEl.style.height = 'auto';

// //         contentEl.offsetHeight;

// //         const topBar = 60;
// //         const padding = 16;
// //         const contentHeight = contentEl.scrollHeight;

// //         contentEl.style.visibility = wasVisible;
// //         contentEl.style.pointerEvents = wasPointerEvents;
// //         contentEl.style.position = wasPosition;
// //         contentEl.style.height = wasHeight;

// //         return topBar + contentHeight + padding;
// //       }
// //     }
// //     return 260;
// //   };

// //   const createTimeline = () => {
// //     const navEl = navRef.current;
// //     if (!navEl) return null;

// //     gsap.set(navEl, { height: 60, overflow: 'hidden' });
// //     gsap.set(cardsRef.current, { y: 50, opacity: 0 });

// //     const tl = gsap.timeline({ paused: true });

// //     tl.to(navEl, {
// //       height: calculateHeight,
// //       duration: 0.4,
// //       ease
// //     });

// //     tl.to(cardsRef.current, { y: 0, opacity: 1, duration: 0.4, ease, stagger: 0.08 }, '-=0.1');

// //     return tl;
// //   };

// //   useLayoutEffect(() => {
// //     const tl = createTimeline();
// //     tlRef.current = tl;

// //     return () => {
// //       tl?.kill();
// //       tlRef.current = null;
// //     };
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [ease, items]);

// //   useLayoutEffect(() => {
// //     const handleResize = () => {
// //       if (!tlRef.current) return;

// //       if (isExpanded) {
// //         const newHeight = calculateHeight();
// //         gsap.set(navRef.current, { height: newHeight });

// //         tlRef.current.kill();
// //         const newTl = createTimeline();
// //         if (newTl) {
// //           newTl.progress(1);
// //           tlRef.current = newTl;
// //         }
// //       } else {
// //         tlRef.current.kill();
// //         const newTl = createTimeline();
// //         if (newTl) {
// //           tlRef.current = newTl;
// //         }
// //       }
// //     };

// //     window.addEventListener('resize', handleResize);
// //     return () => window.removeEventListener('resize', handleResize);
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [isExpanded]);

// //   const toggleMenu = () => {
// //     const tl = tlRef.current;
// //     if (!tl) return;
// //     if (!isExpanded) {
// //       setIsHamburgerOpen(true);
// //       setIsExpanded(true);
// //       tl.play(0);
// //     } else {
// //       setIsHamburgerOpen(false);
// //       tl.eventCallback('onReverseComplete', () => setIsExpanded(false));
// //       tl.reverse();
// //     }
// //   };

// //   const setCardRef = i => el => {
// //     if (el) cardsRef.current[i] = el;
// //   };

// //   return (
// //     <div className={`card-nav-container ${className}`}>
// //       <nav ref={navRef} className={`card-nav ${isExpanded ? 'open' : ''}`} style={{ backgroundColor: baseColor }}>
// //         <div className="card-nav-top">
// //           <div
// //             className={`hamburger-menu ${isHamburgerOpen ? 'open' : ''}`}
// //             onClick={toggleMenu}
// //             role="button"
// //             aria-label={isExpanded ? 'Close menu' : 'Open menu'}
// //             tabIndex={0}
// //             style={{ color: menuColor || '#000' }}
// //           >
// //             <div className="hamburger-line" />
// //             <div className="hamburger-line" />
// //           </div>

// //           <div className="logo-container">
// //             <img src={logo} alt={logoAlt} className="logo" />
// //           </div>

// //           <button
// //             type="button"
// //             className="card-nav-cta-button"
// //             style={{ backgroundColor: buttonBgColor, color: buttonTextColor }}
// //           >
// //             {ctaText}
// //           </button>
// //         </div>

// //         <div className="card-nav-content" aria-hidden={!isExpanded}>
// //           {(items || []).slice(0, 3).map((item, idx) => (
// //             <div
// //               key={`${item.label}-${idx}`}
// //               className="nav-card"
// //               ref={setCardRef(idx)}
// //               style={{ backgroundColor: item.bgColor, color: item.textColor }}
// //             >
// //               <div className="nav-card-label">{item.label}</div>
// //               <div className="nav-card-links">
// //                 {item.links?.map((lnk, i) => (
// //                   <a key={`${lnk.label}-${i}`} className="nav-card-link" href={lnk.href || '#'} aria-label={lnk.ariaLabel}>
// //                     <GoArrowUpRight className="nav-card-link-icon" aria-hidden="true" />
// //                     {lnk.label}
// //                   </a>
// //                 ))}
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </nav>
// //     </div>
// //   );
// // };

// // export default CardNav;

// import { useLayoutEffect, useRef, useState } from 'react';
// import { gsap } from 'gsap';
// // Menggunakan react-icons seperti di contoh Anda
// import { GoArrowUpRight } from 'react-icons/go';
// import './CardNav.css'; // DIHAPUS - Kita akan pindahkan impor ini

// const CardNav = ({
//   logo,
//   logoAlt = 'Logo',
//   items,
//   className = '',
//   ease = 'power3.out',
//   baseColor = '#fff',
//   menuColor,
//   buttonBgColor,
//   buttonTextColor,
//   ctaText = 'Get Started' // Menambahkan prop untuk teks tombol
// }) => {
//   const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);
//   const [isExpanded, setIsExpanded] = useState(false);
//   const navRef = useRef(null);
//   const cardsRef = useRef([]);
//   const tlRef = useRef(null);

//   const calculateHeight = () => {
//     const navEl = navRef.current;
//     if (!navEl) return 260;

//     const isMobile = window.matchMedia('(max-width: 768px)').matches;
//     if (isMobile) {
//       const contentEl = navEl.querySelector('.card-nav-content');
//       if (contentEl) {
//         const wasVisible = contentEl.style.visibility;
//         const wasPointerEvents = contentEl.style.pointerEvents;
//         const wasPosition = contentEl.style.position;
//         const wasHeight = contentEl.style.height;

//         contentEl.style.visibility = 'visible';
//         contentEl.style.pointerEvents = 'auto';
//         contentEl.style.position = 'static';
//         contentEl.style.height = 'auto';

//         contentEl.offsetHeight;

//         const topBar = 60;
//         const padding = 16;
//         const contentHeight = contentEl.scrollHeight;

//         contentEl.style.visibility = wasVisible;
//         contentEl.style.pointerEvents = wasPointerEvents;
//         contentEl.style.position = wasPosition;
//         contentEl.style.height = wasHeight;

//         return topBar + contentHeight + padding;
//       }
//     }
//     return 260;
//   };

//   const createTimeline = () => {
//     const navEl = navRef.current;
//     if (!navEl) return null;

//     gsap.set(navEl, { height: 60, overflow: 'hidden' });
//     gsap.set(cardsRef.current, { y: 50, opacity: 0 });

//     const tl = gsap.timeline({ paused: true });

//     tl.to(navEl, {
//       height: calculateHeight,
//       duration: 0.4,
//       ease
//     });

//     tl.to(cardsRef.current, { y: 0, opacity: 1, duration: 0.4, ease, stagger: 0.08 }, '-=0.1');

//     return tl;
//   };

//   useLayoutEffect(() => {
//     const tl = createTimeline();
//     tlRef.current = tl;

//     return () => {
//       tl?.kill();
//       tlRef.current = null;
//     };

//   }, [ease, items]);

//   useLayoutEffect(() => {
//     const handleResize = () => {
//       if (!tlRef.current) return;

//       if (isExpanded) {
//         const newHeight = calculateHeight();
//         gsap.set(navRef.current, { height: newHeight });

//         tlRef.current.kill();
//         const newTl = createTimeline();
//         if (newTl) {
//           newTl.progress(1);
//           tlRef.current = newTl;
//         }
//       } else {
//         tlRef.current.kill();
//         const newTl = createTimeline();
//         if (newTl) {
//           tlRef.current = newTl;
//         }
//       }
//     };

//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);

//   }, [isExpanded]);

//   const toggleMenu = () => {
//     const tl = tlRef.current;
//     if (!tl) return;
//     if (!isExpanded) {
//       setIsHamburgerOpen(true);
//       setIsExpanded(true);
//       tl.play(0);
//     } else {
//       setIsHamburgerOpen(false);
//       tl.eventCallback('onReverseComplete', () => setIsExpanded(false));
//       tl.reverse();
//     }
//   };

//   const setCardRef = i => el => {
//     if (el) cardsRef.current[i] = el;
//   };

//   return (
//     <div className={`card-nav-container ${className}`}>
//       <nav ref={navRef} className={`card-nav ${isExpanded ? 'open' : ''}`} style={{ backgroundColor: baseColor }}>
//         <div className="card-nav-top">
//           <div
//             className={`hamburger-menu ${isHamburgerOpen ? 'open' : ''}`}
//             onClick={toggleMenu}
//             role="button"
//             aria-label={isExpanded ? 'Close menu' : 'Open menu'}
//             tabIndex={0}
//             style={{ color: menuColor || '#000' }}
//           >
//             <div className="hamburger-line" />
//             <div className="hamburger-line" />
//           </div>

//           <div className="logo-container">
//             <img src={logo} alt={logoAlt} className="logo" />
//           </div>

//           <button
//             type="button"
//             className="card-nav-cta-button"
//             style={{ backgroundColor: buttonBgColor, color: buttonTextColor }}
//           >
//             {ctaText}
//           </button>
//         </div>

//         <div className="card-nav-content" aria-hidden={!isExpanded}>
//           {(items || []).slice(0, 3).map((item, idx) => (
//             <div
//               key={`${item.label}-${idx}`}
//               className="nav-card"
//               ref={setCardRef(idx)}
//               style={{ backgroundColor: item.bgColor, color: item.textColor }}
//             >
//               <div className="nav-card-label">{item.label}</div>
//               <div className="nav-card-links">
//                 {item.links?.map((lnk, i) => (
//                   <a key={`${lnk.label}-${i}`} className="nav-card-link" href={lnk.href || '#'} aria-label={lnk.ariaLabel}>
//                     <GoArrowUpRight className="nav-card-link-icon" aria-hidden="true" />
//                     {lnk.label}
//                   </a>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       </nav>
//     </div>
//   );
// };

// export default CardNav;

import { useLayoutEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ArrowUpRight } from 'lucide-react';
import '@/components/CardNav.css';

const CardNav = ({
  logo,
  logoAlt = 'Logo',
  items,
  className = '',
  ease = 'power3.out',
  baseColor = '#fff',
  menuColor,
  buttonBgColor,
  buttonTextColor,
  ctaText = 'Get Started',
  ctaHref = null
}) => {
  const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const navRef = useRef(null);
  const cardsRef = useRef([]);
  const tlRef = useRef(null);

  const calculateHeight = () => {
    const navEl = navRef.current;
    if (!navEl) return 260;

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (isMobile) {
      const contentEl = navEl.querySelector('.card-nav-content');
      if (contentEl) {
        const wasVisible = contentEl.style.visibility;
        const wasPointerEvents = contentEl.style.pointerEvents;
        const wasPosition = contentEl.style.position;
        const wasHeight = contentEl.style.height;

        contentEl.style.visibility = 'visible';
        contentEl.style.pointerEvents = 'auto';
        contentEl.style.position = 'static';
        contentEl.style.height = 'auto';

        contentEl.offsetHeight;

        const topBar = 60;
        const padding = 16;
        const contentHeight = contentEl.scrollHeight;

        contentEl.style.visibility = wasVisible;
        contentEl.style.pointerEvents = wasPointerEvents;
        contentEl.style.position = wasPosition;
        contentEl.style.height = wasHeight;

        return topBar + contentHeight + padding;
      }
    }
    return 260;
  };

  const createTimeline = () => {
    const navEl = navRef.current;
    if (!navEl) return null;

    gsap.set(navEl, { height: 60, overflow: 'hidden' });
    gsap.set(cardsRef.current, { y: 50, opacity: 0 });

    const tl = gsap.timeline({ paused: true });

    tl.to(navEl, {
      height: calculateHeight,
      duration: 0.4,
      ease
    });

    tl.to(cardsRef.current, { y: 0, opacity: 1, duration: 0.4, ease, stagger: 0.08 }, '-=0.1');

    return tl;
  };

  useLayoutEffect(() => {
    const tl = createTimeline();
    tlRef.current = tl;

    return () => {
      tl?.kill();
      tlRef.current = null;
    };

  }, [ease, items]);

  useLayoutEffect(() => {
    const handleResize = () => {
      if (!tlRef.current) return;

      if (isExpanded) {
        const newHeight = calculateHeight();
        gsap.set(navRef.current, { height: newHeight });

        tlRef.current.kill();
        const newTl = createTimeline();
        if (newTl) {
          newTl.progress(1);
          tlRef.current = newTl;
        }
      } else {
        tlRef.current.kill();
        const newTl = createTimeline();
        if (newTl) {
          tlRef.current = newTl;
        }
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);

  }, [isExpanded]);

  const toggleMenu = () => {
    const tl = tlRef.current;
    if (!tl) return;
    if (!isExpanded) {
      setIsHamburgerOpen(true);
      setIsExpanded(true);
      tl.play(0);
    } else {
      setIsHamburgerOpen(false);
      tl.eventCallback('onReverseComplete', () => setIsExpanded(false));
      tl.reverse();
    }
  };

  const setCardRef = i => el => {
    if (el) cardsRef.current[i] = el;
  };

  return (
    <div className={`card-nav-container ${className}`}>
      <nav ref={navRef} className={`card-nav ${isExpanded ? 'open' : ''}`} style={{ backgroundColor: baseColor }}>
        {/* --- PERUBAHAN DI SINI --- */}
        {/* Menambahkan 'items-center' untuk perataan vertikal */}
        <div className="card-nav-top flex items-center justify-between px-4 h-full">
          {/* Hamburger Menu */}
          <div
            className={`hamburger-menu ${isHamburgerOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            role="button"
            aria-label={isExpanded ? 'Close menu' : 'Open menu'}
            tabIndex={0}
            style={{ color: menuColor || '#000' }}
          >
            <div className="hamburger-line" />
            <div className="hamburger-line" />
          </div>

          {/* Logo */}
          <div className="logo-container flex items-center justify-center h-full"> {/* Menambahkan flex dan justify-center untuk logo */}
            <img src={logo} alt={logoAlt} className="logo h-8" /> {/* Mengatur tinggi logo */}
          </div>

          {/* Tombol CTA */}
          {ctaHref ? (
            <a
              href={ctaHref}
              target="_blank"
              rel="noopener noreferrer"
              className="card-nav-cta-button py-2 px-4 rounded-full text-sm font-semibold flex items-center justify-center" // Menambahkan padding, border-radius, font-size, dan flex
              style={{ backgroundColor: buttonBgColor, color: buttonTextColor }}
            >
              {ctaText}
            </a>
          ) : (
            <button
              type="button"
              className="card-nav-cta-button py-2 px-4 rounded-full text-sm font-semibold flex items-center justify-center" // Menambahkan padding, border-radius, font-size, dan flex
              style={{ backgroundColor: buttonBgColor, color: buttonTextColor }}
            >
              {ctaText}
            </button>
          )}
        </div>
        {/* --- AKHIR PERUBAHAN --- */}

        <div className="card-nav-content" aria-hidden={!isExpanded}>
          {(items || []).slice(0, 3).map((item, idx) => (
            <div
              key={`${item.label}-${idx}`}
              className="nav-card"
              ref={setCardRef(idx)}
              style={{ backgroundColor: item.bgColor, color: item.textColor }}
            >
              <div className="nav-card-label">{item.label}</div>
              <div className="nav-card-links">
                {item.links?.map((lnk, i) => (
                  <a 
                    key={`${lnk.label}-${i}`} 
                    className="nav-card-link" 
                    href={lnk.href || '#'} 
                    aria-label={lnk.ariaLabel}
                    target={lnk.href.startsWith('#') ? '_self' : '_blank'}
                    rel="noopener noreferrer"
                  >
                    <ArrowUpRight className="nav-card-link-icon" aria-hidden="true" />
                    {lnk.label}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </nav>
    </div>
  );
};

export default CardNav;